/* FABLE cart drawer engine — perkurtas nuo 0 (v2 po adversarinės peržiūros).
   Mechanika: fetch/XHR patch aptinka /cart/add iš bet kur → atidaro drawer,
   kiekio nuolaidų kodai (PREK10/15/20) pritaikomi automatiškai per /discount/.
   v2: klaidų apdorojimas (422/network → toast, ne užstrigęs busy), vienkartinis
   event binding (be akumuliacijos po refresh), buy-now suppression per visą kelią,
   minus@1 neištrina prekės, fokusas į dialogą. */
(function () {
  'use strict';
  var SECTION = 'fable-cart-drawer';
  var instance = null;

  /* ---------- helpers ---------- */
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function getJSON(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function tierCodeFor(count) {
    count = parseInt(count, 10) || 0;
    if (count >= 4) return 'PREK20';
    if (count === 3) return 'PREK15';
    if (count === 2) return 'PREK10';
    return null;
  }
  function couponInCart(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var p = items[i].properties;
      if (p && p._cpn) return String(p._cpn);
    }
    return null;
  }
  function userCode(cart) {
    var a = cart && cart.attributes;
    var c = a && (a.fc_code || a.FC_CODE);
    c = c ? String(c).trim() : '';
    return c ? c.toUpperCase() : null;
  }
  function isTierCode(c) { return /^PREK(10|15|20)$/i.test(c || ''); }
  function tierEligibleCount(cart) {
    /* 1+1 (BOGO) prekės į kiekio nuolaidos pakopą nesiskaičiuoja — antra jau dovanų kainoje */
    var items = (cart && cart.items) || null;
    if (!items) return (cart && cart.item_count) || 0;
    var n = 0, hasBogo = false;
    for (var i = 0; i < items.length; i++) {
      var p = items[i].properties;
      if (p && p._1plus1) { hasBogo = true; continue; }
      if (p && p._priedas) { continue; } /* priedai (karoliai/apyrankė) į kiekio pakopą nesiskaičiuoja */
      n += items[i].quantity || 0;
    }
    return hasBogo ? 0 : n; /* 1+1 krepšelyje -> kiekio nuolaida nesikombinuoja */
  }
  function legacyApplyCodes(codes) {
    /* atsarginis kelias — senas /discount/ cookie mechanizmas, po vieną paeiliui */
    return (codes || []).reduce(function (p, code) {
      return p.then(function () {
        return fetch(shopRoot() + 'discount/' + encodeURIComponent(code), {
          method: 'GET', credentials: 'same-origin', redirect: 'manual'
        }).then(function () {}, function () {});
      });
    }, Promise.resolve()).then(function () { return null; });
  }
  function desiredCodes(cart, extra) {
    var seen = {}, out = [];
    function push(c) {
      if (!c) return;
      c = String(c).trim();
      if (!c) return;
      var k = c.toUpperCase();
      if (!seen[k]) { seen[k] = 1; out.push(c); }
    }
    /* išsaugom svetimus kodus (pvz. iš reklamos /discount/ nuorodos), pasenusius tier kodus išmetam */
    ((cart && cart.discount_codes) || []).forEach(function (d) {
      var c = d && d.code;
      if (c && !isTierCode(c)) push(c);
    });
    push(couponInCart(cart));
    push(userCode(cart));
    push(extra);
    push(tierCodeFor(tierEligibleCount(cart)));
    return out;
  }
  /* Nuolaidų sinchronizacija per Cart AJAX API — update.js palaiko „discount":
     kodai gyvena ant paties krepšelio, drawer rodo TIKRĄ perskaičiuotą sumą,
     checkout kodus paveldi. Nesikombinuojantiems kodams Shopify pats palieka
     klientui didžiausią nuolaidą. Jei API nepalaikytų — legacy /discount/ kelias. */
  function setCartDiscounts(cart, extra, attrs) {
    var codes = desiredCodes(cart, extra);
    if (!attrs && cart && cart.discount_codes) {
      var cur = cart.discount_codes.map(function (d) { return String((d && d.code) || '').toUpperCase(); }).sort().join(',');
      var want = codes.map(function (c) { return c.toUpperCase(); }).sort().join(',');
      if (cur === want) return Promise.resolve(cart); /* niekas nesikeičia — POST nereikalingas */
    }
    var body = { discount: codes.join(',') };
    if (attrs) body.attributes = attrs;
    return postJSON(shopRoot() + 'cart/update.js', body).then(function (c) {
      if (c && c.discount_codes) return c;
      throw new Error('cart-api');
    }).catch(function () { return legacyApplyCodes(codes); });
  }
  function cartSuppressed() {
    return window.__phSuppressCartOpen && (Date.now() - window.__phSuppressCartOpen < 4000);
  }

  /* ---------- add-to-cart detektorius (fetch + XHR, bet koks šaltinis) ---------- */
  function isAddUrl(u) { return typeof u === 'string' && u.indexOf('/cart/add') !== -1; }
  var addTimer = null;
  function onCartAdd() {
    /* suppressed (quickbuy/buy-now) — drawer neatidarom, bet kiekio kodus vis tiek pritaikom */
    clearTimeout(addTimer);
    addTimer = setTimeout(function () { if (instance) instance.afterAdd(); }, 60);
  }
  function onCartAddFailed(detail) {
    if (!instance || cartSuppressed()) return;
    instance.addFailed(detail);
  }
  (function patchFetch() {
    var orig = window.fetch;
    if (typeof orig !== 'function') return;
    function wrap(fn) {
      return function () {
        var args = arguments;
        try {
          var f0 = args[0]; var u0 = f0 && f0.url ? f0.url : f0;
          if (isAddUrl(u0) && instance && !cartSuppressed()) instance.open(true);
        } catch (e) {}
        var p = fn.apply(this, args);
        try {
          var first = args[0]; var u = first && first.url ? first.url : first;
          if (isAddUrl(u) && p && typeof p.then === 'function') {
            p.then(function (r) {
              if (!r || r.ok !== false) { onCartAdd(); return; }
              /* 422 / kita klaida — parsinti aprašymą ir parodyti */
              try {
                r.clone().json().then(function (j) {
                  onCartAddFailed(j && (j.description || j.message));
                }).catch(function () { onCartAddFailed(); });
              } catch (e) { onCartAddFailed(); }
            }).catch(function () { onCartAddFailed(); });
          }
        } catch (e) {}
        return p;
      };
    }
    var wrapped = wrap(orig);
    try {
      Object.defineProperty(window, 'fetch', {
        configurable: true,
        get: function () { return wrapped; },
        set: function (v) { wrapped = wrap(v); }
      });
    } catch (e) { window.fetch = wrapped; }
  })();
  (function patchXHR() {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, url) { this.__fcUrl = url; return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      try { if (isAddUrl('' + self.__fcUrl) && instance && !cartSuppressed()) instance.open(true); } catch (e) {}
      this.addEventListener('load', function () {
        try {
          if (!isAddUrl('' + self.__fcUrl)) return;
          if (self.status >= 200 && self.status < 300) onCartAdd();
          else onCartAddFailed();
        } catch (e) {}
      });
      this.addEventListener('error', function () {
        try { if (isAddUrl('' + self.__fcUrl)) onCartAddFailed(); } catch (e) {}
      });
      return send.apply(this, arguments);
    };
  })();

  /* ---------- krepšelio ikonų perėmimas ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"], a[href*="/cart?"], [data-fc-open]');
    if (!t) return;
    if (t.closest('fable-cart-drawer')) return;
    if (!instance) return;
    e.preventDefault();
    e.stopPropagation();
    instance.refresh().then(function () { instance.open(false); });
  }, true);

  /* ---------- web component ---------- */
  function FCDrawer() { return Reflect.construct(HTMLElement, [], FCDrawer); }
  FCDrawer.prototype = Object.create(HTMLElement.prototype);
  FCDrawer.prototype.constructor = FCDrawer;

  FCDrawer.prototype.connectedCallback = function () {
    instance = this;
    this._busy = false;
    this._lastFocus = null;
    if (this.__fcBound) return; /* saugiklis nuo pakartotinio connect */
    this.__fcBound = true;
    var self = this;
    /* VIENAS deleguotas listeneris — veikia ir po innerHTML refresh, be akumuliacijos */
    this.addEventListener('click', function (e) {
      if (e.target.closest('[data-fc-close]')) { self.close(); return; }
      var minus = e.target.closest('[data-fc-minus]');
      var plus = e.target.closest('[data-fc-plus]');
      var rm = e.target.closest('[data-fc-remove]');
      if (minus || plus) {
        var btn = minus || plus;
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        var box = btn.closest('.fc-qty');
        var key = box.getAttribute('data-key');
        var cur = parseInt(box.querySelector('.fc-qty__v').textContent, 10) || 1;
        if (minus && cur <= 1) { self.changeQty(key, 0); return; } /* trynimas — tik per šiukšliadėžę */
        self.changeQty(key, plus ? cur + 1 : cur - 1);
      } else if (rm) {
        self.changeQty(rm.getAttribute('data-key'), 0);
      }
    });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') self.close(); });
  };

  FCDrawer.prototype.open = function (pending) {
    var wasOpen = this.classList.contains('is-open');
    this.classList.add('is-open');
    document.body.classList.add('fc-open');
    document.documentElement.style.overflow = 'hidden';
    if (pending) this.setBusy(true);
    if (!wasOpen) {
      this._lastFocus = document.activeElement;
      var panel = this.querySelector('.fc__panel');
      if (panel) { panel.setAttribute('tabindex', '-1'); try { panel.focus({ preventScroll: true }); } catch (e) {} }
    }
  };
  FCDrawer.prototype.close = function () {
    this.classList.remove('is-open');
    document.body.classList.remove('fc-open');
    document.documentElement.style.overflow = '';
    this.setBusy(false);
    if (this._lastFocus && this._lastFocus.focus) { try { this._lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    this._lastFocus = null;
  };
  FCDrawer.prototype.setBusy = function (on) {
    var sc = this.querySelector('.fc__scroll');
    if (sc) sc.style.opacity = on ? '.45' : '';
  };
  FCDrawer.prototype.showError = function (msg) {
    var panel = this.querySelector('.fc__panel');
    if (!panel) return;
    var t = panel.querySelector('.fc-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'fc-toast';
      t.setAttribute('role', 'alert');
      panel.appendChild(t);
    }
    t.textContent = msg || 'Nepavyko atnaujinti krepšelio — bandykite dar kartą';
    t.classList.add('is-show');
    clearTimeout(this.__toastT);
    this.__toastT = setTimeout(function () { t.classList.remove('is-show'); }, 5000);
  };
  FCDrawer.prototype.addFailed = function (detail) {
    var self = this;
    this.refresh().then(function () {
      self.setBusy(false);
      self.showError(typeof detail === 'string' && detail ? detail : 'Nepavyko pridėti prekės — bandykite dar kartą');
    });
  };

  FCDrawer.prototype.changeQty = function (key, qty) {
    if (this._busy) return;
    this._busy = true;
    var item = this.querySelector('.fc-item[data-key="' + key + '"]');
    if (item) item.classList.add('is-busy');
    var self = this;
    postJSON(shopRoot() + 'cart/change.js', { id: key, quantity: qty })
      .then(function (cart) { return self.syncTier(cart); })
      .then(function () { return self.refresh(); })
      .catch(function () {
        if (item) item.classList.remove('is-busy');
        self.showError();
        return self.refresh();
      })
      .finally(function () { self._busy = false; self.setBusy(false); });
  };

  FCDrawer.prototype.afterAdd = function () {
    var quiet = cartSuppressed();
    var self = this;
    getJSON(shopRoot() + 'cart.js')
      .then(function (cart) { return self.syncTier(cart); })
      .then(function () { return self.refresh(); })
      .then(function () { if (!quiet) self.open(false); self.setBusy(false); })
      .catch(function () { self.setBusy(false); });
  };

  FCDrawer.prototype.syncTier = function (cart) {
    return setCartDiscounts(cart, null, null);
  };

  /* Drawer kupono mygtukui: pritaiko įvestą kodą + kuponą + esamą kiekio tier kartu.
     Grąžina { applied, code } — ar Shopify kodą realiai pritaikė. */
  window.FCApplyDiscounts = function (extraCode) {
    return getJSON(shopRoot() + 'cart.js').then(function (cart) {
      var code = extraCode ? String(extraCode).trim().toUpperCase() : '';
      var attrs = null;
      var cpn = (couponInCart(cart) || '').toUpperCase();
      if (code && code !== cpn) attrs = { fc_code: code };
      return setCartDiscounts(cart, code, attrs).then(function (c) {
        if (!code) return { applied: true, code: code };
        var ok = false;
        if (c && c.discount_codes) {
          c.discount_codes.forEach(function (d) {
            if (d && d.code && String(d.code).toUpperCase() === code && d.applicable) ok = true;
          });
        } else { ok = true; } /* legacy kelias — patikrinti negalim */
        return { applied: ok, code: code };
      });
    });
  };

  /* Pašalinti vartotojo įvestą kodą (drawer „ד mygtukas) */
  window.FCRemoveCode = function (code) {
    code = code ? String(code).trim().toUpperCase() : '';
    return getJSON(shopRoot() + 'cart.js').then(function (cart) {
      if (cart) {
        cart.discount_codes = (cart.discount_codes || []).filter(function (d) {
          return !(d && d.code && String(d.code).toUpperCase() === code);
        });
        if (cart.attributes) cart.attributes.fc_code = '';
      }
      return setCartDiscounts(cart, null, { fc_code: '' });
    });
  };

  FCDrawer.prototype.refresh = function () {
    var self = this;
    return fetch(shopRoot() + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#FableCartContent');
        var mine = self.querySelector('#FableCartContent');
        if (fresh && mine) mine.innerHTML = fresh.innerHTML;
        /* FAB */
        var freshFab = doc.querySelector('.fc-fab');
        var myFab = document.querySelector('.fc-fab');
        if (freshFab && myFab) {
          var n = freshFab.querySelector('[data-fc-fab-count]');
          var mn = myFab.querySelector('[data-fc-fab-count]');
          if (n && mn) { mn.textContent = n.textContent; mn.hidden = n.hidden; }
          if (freshFab.hasAttribute('data-empty')) myFab.setAttribute('data-empty', ''); else myFab.removeAttribute('data-empty');
        }
        /* Dawn header burbuliukas */
        try {
          var cnt = doc.querySelector('.fc-head__count');
          var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
          if (bubble) bubble.textContent = cnt ? cnt.textContent : '0';
        } catch (e) {}
        self.setBusy(false);
        try { if (window.phCartRefresh) window.phCartRefresh(); } catch (e) {}
      })
      .catch(function () { self.setBusy(false); });
  };

  if (!customElements.get('fable-cart-drawer')) customElements.define('fable-cart-drawer', FCDrawer);
})();
